import axios from 'axios';
import { Dispatch } from 'redux';
import { TourCategory, TourCategoryData, TourCategoryCmsData } from "@/data/types";


// Action Types
const GET_TOUR_CATEGORIES = '[TOUR CATEGORIES] GET TOUR CATEGORIES';
const GET_TOUR_CATEGORY_DATA = '[TOUR CATEGORIES] GET TOUR CATEGORY DATA';
const GET_TOUR_CATEGORY_CMS_DATA = '[TOUR CATEGORIES] GET TOUR CATEGORY CMS DATA';

// Action Interfaces
interface GetTourCategoriesAction {
  type: typeof GET_TOUR_CATEGORIES;
  payload: TourCategory[];
}

interface GetTourCategoryDataAction {
  type: typeof GET_TOUR_CATEGORY_DATA;
  payload: TourCategoryData;
}

interface GetTourCategoryCmsDataAction {
  type: typeof GET_TOUR_CATEGORY_CMS_DATA;
  payload: TourCategoryCmsData[];
}

// Async Action Creator for Tour Categories
export const getTourCategories = (activated: boolean, language: string) => async (dispatch: Dispatch<GetTourCategoriesAction>) => {
  try {
    const params = { ...(activated !== undefined && { activated }), language };
    const response = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/tour-categories`, { params });

    if (response.data) {
      dispatch({
        type: GET_TOUR_CATEGORIES,
        payload: response.data.sort((a: TourCategory, b: TourCategory) => a.order - b.order),
      });
    } else {
      // Handle no data case
    }
  } catch (error) {
    console.error('Error fetching tour categories:', error);
    // Handle error
  }
};

// Sync setter for server-side hydration: lets the home server component
// pre-populate Redux from the SSR fetch so cards are present in the very
// first client render (LCP image discoverable in initial HTML).
export const setTourCategories = (payload: TourCategory[]) => ({
  type: GET_TOUR_CATEGORIES as typeof GET_TOUR_CATEGORIES,
  payload,
});

// Additional action creators for fetching individual tour category data and CMS data
// can be implemented here similar to getContinentData and getContinentCmsData

// Reducer for Tour Categories
const initialState = {
  tourCategories: [],
  currentTourCategoryData: null,
  tourCategoryCmsData: null,
};

const tourCategoriesReducer = (state = initialState, action: GetTourCategoriesAction | GetTourCategoryDataAction | GetTourCategoryCmsDataAction) => {
  switch (action.type) {
    case GET_TOUR_CATEGORIES:
      return {
        ...state,
        tourCategories: action.payload,
      };
    // Handle other actions
    default:
      return state;
  }
};

export default tourCategoriesReducer;
